import { render, staticRenderFns } from "./MenuSingleLayer.vue?vue&type=template&id=5877bac4&scoped=true"
import script from "./MenuSingleLayer.vue?vue&type=script&lang=js"
export * from "./MenuSingleLayer.vue?vue&type=script&lang=js"
import style0 from "./MenuSingleLayer.vue?vue&type=style&index=0&id=5877bac4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877bac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5877bac4')) {
      api.createRecord('5877bac4', component.options)
    } else {
      api.reload('5877bac4', component.options)
    }
    module.hot.accept("./MenuSingleLayer.vue?vue&type=template&id=5877bac4&scoped=true", function () {
      api.rerender('5877bac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/MenuSingleLayer.vue"
export default component.exports